export function toPascalCase(str: string) {
  return str
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
